import { render, staticRenderFns } from "./userNiou.vue?vue&type=template&id=15f3761b&scoped=true&"
import script from "./userNiou.vue?vue&type=script&lang=js&"
export * from "./userNiou.vue?vue&type=script&lang=js&"
import style0 from "./userNiou.vue?vue&type=style&index=0&id=15f3761b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3761b",
  null
  
)

export default component.exports